export const MANAGEMENT_SEGMENT_KEY_ISSUES = 'keyIssues';
export const MANAGEMENT_SEGMENT_BOARD_GOVERNANCE = 'boardGovernance';

export const MANAGEMENT_SEGMENT_OPT = [
  {
    text: 'Key Issues',
    value: MANAGEMENT_SEGMENT_KEY_ISSUES,
    disabled: false,
  },
  {
    text: 'Board Governance',
    value: MANAGEMENT_SEGMENT_BOARD_GOVERNANCE,
    disabled: false,
  },
];

export const LOG_MAP: any = {
  [MANAGEMENT_SEGMENT_KEY_ISSUES]: 'STUDIO_OVERALL_MANAGEMENT_KEY_ISSUES',
  [MANAGEMENT_SEGMENT_BOARD_GOVERNANCE]: 'STUDIO_OVERALL_MANAGEMENT_BOARD_GOVERNANCE',
};
